export default __webpack_public_path__ + "static/media/longerRange.d202a8b5.svg";